__turbopack_context__.v({
  "chevron": "NavbarLanguageMenu-module__5A1CXa__chevron",
  "compact": "NavbarLanguageMenu-module__5A1CXa__compact",
  "globe": "NavbarLanguageMenu-module__5A1CXa__globe",
  "menu": "NavbarLanguageMenu-module__5A1CXa__menu",
  "menuItem": "NavbarLanguageMenu-module__5A1CXa__menuItem",
  "root": "NavbarLanguageMenu-module__5A1CXa__root",
  "srOnly": "NavbarLanguageMenu-module__5A1CXa__srOnly",
  "toneOnBlue": "NavbarLanguageMenu-module__5A1CXa__toneOnBlue",
  "trigger": "NavbarLanguageMenu-module__5A1CXa__trigger",
});
